<div class="d-flex flex-wrap">
  @for (item of items; track $index) {
  <button
    type="button"
    [id]="item.name"
    (click)="toggle(item)"
    [disabled]="item.disabled"
    [ngbTooltip]="item.tooltip"
    [ngClass]="item.active ? 'btn-primary' : 'btn-outline-primary'"
    class="btn btn-sm rounded-pill me-4"
  >
    {{ item.title }}
  </button>
  @if (item.endOfLine) {
  <div class="w-100"></div>
  } }
</div>
